<section class="us">
  <h1 class="us__title">{{ 'home.us.title' | translate }}</h1>
  <p class="us__subtitle">{{ 'home.us.subtitle' | translate }}</p>

  <dl class="us__facts">
    <div class="us__fact">
      <dt class="us__fact-label">{{ 'home.us.companyName' | translate }}</dt>
      <dd class="us__fact-value">Partiri i.G</dd>
    </div>
    <div class="us__fact">
      <dt class="us__fact-label">{{ 'home.us.address' | translate }}</dt>
      <dd class="us__fact-value">Torstraße 105-107<br />10119 Berlin</dd>
    </div>
    <div class="us__fact">
      <dt class="us__fact-label">{{ 'home.us.email' | translate }}</dt>
      <dd class="us__fact-value"><a href="mailto:legal@partiri.cloud" class="us__link">legal&#64;partiri.cloud</a></dd>
    </div>
  </dl>
</section>
